import { render, staticRenderFns } from "./AboutUsContent.vue?vue&type=template&id=4cadf0f2&scoped=true"
import script from "./AboutUsContent.vue?vue&type=script&lang=ts"
export * from "./AboutUsContent.vue?vue&type=script&lang=ts"
import style0 from "./AboutUsContent.vue?vue&type=style&index=0&id=4cadf0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cadf0f2",
  null
  
)

export default component.exports